/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Table_TitleInputs */

const en_pc_cmp_table_title = /** @type {(inputs: Pc_Cmp_Table_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature by feature`)
};

const zh_pc_cmp_table_title = /** @type {(inputs: Pc_Cmp_Table_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逐项功能对比`)
};

/**
* | output |
* | --- |
* | "Feature by feature" |
*
* @param {Pc_Cmp_Table_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_table_title = /** @type {((inputs?: Pc_Cmp_Table_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Table_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_table_title(inputs)
	return zh_pc_cmp_table_title(inputs)
});
export { pc_cmp_table_title as "pc.cmp.table_title" }